'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbSearchFormController.$inject = ['SearchConstants', 'Relay42Service', '$window', '$interval'];


var _module = _angular2.default.module('cb.core.search.cbSearchFormController', []);

_module.controller('cbSearchFormController', cbSearchFormController);

exports.default = _module;


function cbSearchFormController(SearchConstants, Relay42Service, $window, $interval) {
    var vm = this;

    vm.resultsUrl = SearchConstants.RESULTS_URL;
    vm.refinementStyle = SearchConstants.REFINEMENT_STYLE;
    vm.hideGoogleSearch;
    vm.onResultsPage;

    vm.setSearch = setSearch;

    init();

    function init() {
        //On results page, don't show searchbox because it doesn't work than
        if ($window.location.pathname === vm.resultsUrl) {
            vm.onResultsPage = true;
        }
        setSearch();
    }
    var i;

    function setSearch() {
        Relay42Service.getCookiePermissionLevel().then(function (level) {
            if (level >= 2) {
                vm.hideGoogleSearch = false;

                if (!vm.onResultsPage) {
                    require('./vendor/google-search.js');
                }
            } else {
                vm.hideGoogleSearch = true;
            }
        });
    }
}

function setPlaceholder() {
    var searchbox = $('gsc-i-id1');
    if (searchbox.length > 0) {
        $('gsc-i-id1').attr('placeholder', 'Waar bent u naar op zoek?');
        $interval.cancel(i);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/cb-search-form.controller.js
// module id = 818
// module chunks = 0